import { render, staticRenderFns } from "./CardRecycling.vue?vue&type=template&id=76f2bc6c&scoped=true"
import script from "./CardRecycling.vue?vue&type=script&setup=true&lang=js"
export * from "./CardRecycling.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CardRecycling.vue?vue&type=style&index=0&id=76f2bc6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f2bc6c",
  null
  
)

export default component.exports